angular.module('wbDashboard').controller('PortfolioplusCoreControllerAurea',
        ['$scope', '$q', '$uibModal', 'RiskScore', 'User', 'Milestone', 'PlanService', 'Message',
function ($scope, $q, $uibModal, RiskScore, User, Milestone, PlanService, Message) {

    $scope.pageData.positionHighlight = {};

    $scope.pageData.milestonePage = ['cash-amount', 'cash-amount-end', 'allocation-start', 'allocation-end', 'review-glide'];

    $scope.core = {
        ms: null,
        recommendations: {}
    };
    $scope.modScope = null;

    if ($scope.$stateParams.page !== "milestones" && (!$scope.core.ms || !$scope.core.allocation_value)) {
        $scope.$state.go('.', {page: "milestones"}, {location: 'replace'});
    }


    // $scope.$watch('core.ms', function(ms) {
    //     if (ms) {
    //     }
    // });
    if ($scope.$stateParams.msId) {
        $scope.$watch('milestoneChoices', function(msChoices) {
            if (msChoices && !$scope.redirected) {
                $scope.redirected = true;
                var ms = msChoices[$scope.$stateParams.msId];
                if (ms) {
                    $scope.setCoreMilestone(ms);
                    $scope.goNextPage();
                }
            }
        });
    }


    $scope.setCoreMilestone = function(msSelected) {

        Milestone.clearMS();
        Milestone.setMilestoneUpdateFromObject(msSelected);
        $scope.core.ms = Milestone.ms;

        var ms = $scope.core.ms;

        return $q.when(1).then(function() {
            if (!$scope.core.recommendations[ms.id]) {
                return Milestone.getGlideRecommend(ms).then(function(recommended) {
                    $scope.core.recommendations[ms.id] = recommended;
                    return recommended;
                });
            } else {
                return $scope.core.recommendations[ms.id];
            }
        }).then(function(recommended) {
            ms.allocation.recommendation = recommended;

            //in case it's currently a custom portfolio, or either start/end are 0
            if (isNaN(ms.allocation.allocation_start) || ms.allocation.allocation_start === "0.0" || ms.allocation.allocation_end === "0.0") {
                //if triggered twice then the watchgroup won't trigger the second time, so must assign all here first
                ms.allocation.allocation_start = ms.allocation.recommendation.allocation_start;
                ms.allocation.allocation_end = ms.allocation.recommendation.allocation_end;
                ms.extra.allocation_start_value = ms.allocation.recommendation.allocation_start * 1;
                ms.extra.allocation_end_value = ms.allocation.recommendation.allocation_end * 1;

                ms.allocation.cash_start = ms.allocation.recommendation.cash_start;
                ms.allocation.cash_end = ms.allocation.recommendation.cash_end;
                ms.extra.cash_start_percent = ms.allocation.recommendation.cash_start * 100;
                ms.extra.cash_end_percent = ms.allocation.recommendation.cash_end * 100;
            }

        });
    };

    $scope.$watchGroup(['core.ms.extra.allocation_start_value','core.ms.extra.allocation_end_value'], function(data) {
        var [startValue, endValue] = data;

        if (startValue || startValue === 0) {
            $scope.core.ms.allocation.allocation_start = startValue.toFixed(1);
        }
        if (endValue || endValue === 0) {
            $scope.core.ms.allocation.allocation_end = endValue.toFixed(1);
        }
    });

    $scope.$watchGroup(['core.ms.extra.cash_start_percent','core.ms.extra.cash_end_percent'], function(data) {
        var [startPercent, endPercent] = data;

        if (startPercent || endPercent || endPercent === 0) {
            $scope.core.ms.allocation.cash_start = getCashRatio(startPercent);
            $scope.core.ms.allocation.cash_end = getCashRatio(endPercent);
        }

        function getCashRatio(percent) {
            var ratio = null;
            //make sure percent is rounded to whole number
            if (percent || percent === 0) {
                ratio = percent / 100;
            }
            return ratio;
        }
    });


    $scope.savePortfolioModal = function() {
        var modalInstance = $uibModal.open({
            templateUrl: "modal-portfolioplus-core-confirm.tpl.html",
            size: 'md',
            scope: $scope,
            windowClass: 'portfolioplus-asset-save-modal plan-info-confirm-modal'
        });

        modalInstance.result.then(function () {
            $scope.saveMilestonePortfolio();
        }).catch(function (e) {
            if (typeof e !== "string") {
                throw e;
            }
        }).finally(function() {
        });
    };

    $scope.saveMilestonePortfolio = function() {

        $scope.pageData.sending = true;
        var data = {
            allocation_start: $scope.core.ms.allocation.allocation_start,
            allocation_end: $scope.core.ms.allocation.allocation_end,
            cash_start: $scope.core.ms.allocation.cash_start,
            cash_end: $scope.core.ms.allocation.cash_end,
        };
        if ($scope.core.ms.type === 'build_wealth' || $scope.core.ms.type === 'other' || $scope.core.ms.type_account) {
            data.allocation_end = $scope.core.ms.allocation.allocation_start;
            data.cash_end = $scope.core.ms.allocation.cash_start;
        }

        return PlanService.user.setMilestoneAllocation($scope.core.ms.id, data).catch(function(response) {
            Message.set({
                text: "There was a problem saving" + $scope.core.ms.name + " Milestone",
                type: "danger"
            });
            throw response;
        }).then(function() {
            PlanService.user.clearPortfolioExtra();
            return $q.all([
                PlanService.user.retrievePortfolios(null, true),
                //need to remove all data since positions could have changed
                User.retrieveAllMilestones(true, true)
            ]);
        }).then(function() {
            Message.set({
                text: "Successfully saved " + $scope.core.ms.name + " Milestone",
                type: "success"
            });
            $scope.$state.go('base.plans.custom.portfolioplus');
        }).finally(function() {
            $scope.pageData.sending = false;
        });

    };

    $scope.goNextPage = function() {
        var page = null;
        switch ($scope.$stateParams.page) {
            case 'milestones':
                page = 'cash-amount';
                break;
            case 'cash-amount':
                page = 'allocation-start';
                break;
            case 'allocation-start':
                page = 'cash-amount-end';
                if ($scope.core.ms.type === 'build_wealth' || $scope.core.ms.type_account) {
                    page = 'save';
                }
                break;
            case 'cash-amount-end':
                if ($scope.core.ms.allocation.cash_end < 1) {
                    page = 'allocation-end';
                    break;
                } else {
                    //continue to next case ti skip allocation-end
                }
                /* falls through */
            case 'allocation-end':
                page = 'review-glide';
                Milestone.retrieveGlideFuture();
                break;
            case 'review-glide':
                page = 'save';
                break;
        }

        if (page) {
            if (page === 'save') {
                $scope.saveMilestonePortfolio();
            } else {
                $scope.goToPage(page);
            }
        }
    };
    $scope.goToPage = function(page, options = {}) {
        return $scope.$state.go('.', {page: page}, options);
    };

    $scope.viewPortfolioAllocation = function(allocation, cash) {
        var portfolio = angular.copy($scope.riskPortfolios[allocation.toFixed(1)]);

        portfolio = RiskScore.formatPortfolio(portfolio, cash, true);
        portfolio.total_value = 0;
        $scope.riskAllocation = portfolio;

        $scope.goToDetail();
    };

    $scope.goToDetail = function() {
        $scope.$state.go(".",{page:'allocation-detail'});
    };


    var transitionDeregisterHook = $scope.$transitions.onSuccess({ to: $scope.$state.current.name+".**" }, function(trans) {
        $scope.pageData.page = trans.params('to').page;
    });
    $scope.$on('$destroy', function() {
        if (transitionDeregisterHook) {
            transitionDeregisterHook();
        }
    });



}]);
